import React, { useState, useRef, useEffect } from 'react';
import { ExclamationCircleFilled, SearchOutlined } from '@ant-design/icons';
import { Switch, Empty, Table, Button, Col, Tag, Drawer, Form, Input, InputNumber, Row, Select, Space, message, Modal, Typography  } from 'antd';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import {getList as getAllConcepts} from '../../../../apis/ConceptoApi';
import {insert, update, getById} from '../../../../apis/TipoSaldoApi';
import Highlighter from "react-highlight-words";
import _ from 'lodash';


const { Title } = Typography;
const { Option } = Select;
const { confirm } = Modal;
const App = ({title, id, open, finish}) => {
    const [ form ] = Form.useForm()
    const [ID, setID] = useState(id);
    const [modified, setModified] = useState(false);
    const [initialValues, setInitialValues] = useState(null);
    const [concepts, setConcepts] = useState([]);
    const [usa_plazo, setUsaPlazo] = useState(null);
    const searchInput = useRef(null);
    
    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            if(!values) return;
        } catch (errorInfo) {
            console.log('Failed:', errorInfo);
            return;
        }

        const fields = form.getFieldsValue()
        let success = false;
        if(ID > 0){
            //Update
            const payload = {
                id: ID,
                ...fields
            }
            const response = await update(payload);
            success = response.ok;
            if(response.ok){
                message.success('Se actualizó correctamente el tipo de saldo!');
            }
        }else{
            //Create
            const payload = {
                id: ID,
                ...fields
            }
            const response = await insert(payload);
            success = response.ok;
            if(response.ok){
                setID(response.payload);
                message.success('Se guardo correctamente el periodo!');
            }
        }

        if(success){
            setModified(true);
            onClose(true);
        }
    }

    const onClose = (reload)=>{
      finish(reload ?? modified);
      setInitialValues(null);
    }

    const effectRan = useRef(false);
    useEffect(() => {
        if (!effectRan.current) {
            (async () => {
                await getConcepts();
                if(ID > 0){
                    await refreshData();
                }else{
                    setInitialValues({
                        finiquito: false,
                        usa_plazo: false,
                        clase: false
                    });
                }
                setModified(false)
            })();
        }
        return () => effectRan.current = true;
    }, []);

    const refreshData = async ()=> {
        const response = await getById(ID);
        if(response.ok){
            let concept = response.payload;
            setInitialValues(concept);
        }
    }

    const getConcepts = async ()=>{
        const response = await getAllConcepts();
        if(response.ok){
          let conceptsList = response.payload;
          setConcepts(conceptsList);
        }
    }

    return (
        <Drawer
            title={title}
            width={720}
            placement={"right"}
            onClose={onClose}
            open={open}
            closable={true}
            extra={[]}
        >
            <>
                <div style={{height: 50}}>
                    <div style={{float: 'left'}}>
                        <span title=""></span>
                    </div>
                    <span class="" style={{float:'right'}}>
                        <Space>
                            <Button onClick={onClose}>Cancelar</Button>
                            <Button onClick={handleOk} type="primary">
                            Guardar
                            </Button>
                        </Space>
                    </span>
                </div>
                {/* <PageHeader ghost={false} title="Remisiones" extra={[ 
                <Space>
                    <Button onClick={onClose}>Cancelar</Button>
                    <Button onClick={handleOk} type="primary">
                    Guardar
                    </Button>
                </Space>]} />*/}
            {
                initialValues && 
                <Form 
                        layout="vertical" 
                        form={form} 
                        autoComplete="off"
                        initialValues={initialValues} 
                        onFinish={handleOk}>
                        <Row gutter={16}>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="clave"
                                    label="Clave"
                                    rules={[
                                    {
                                        required: true,
                                        message: 'Por favor agrega la clave',
                                    },
                                    ]}
                                >
                                    <Input placeholder="Por favor agrega la clave" />
                                </Form.Item>
                            </Col>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="orden"
                                    label="Orden"
                                    rules={[
                                    {
                                        required: true,
                                        message: 'Por favor agrega el orden',
                                    },
                                    ]}
                                >
                                    <InputNumber placeholder="Por favor agrega el orden" />
                                </Form.Item>
                            </Col>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="descripcion"
                                    label="Descripción"
                                    rules={[
                                    {
                                        required: true,
                                        message: 'Por favor agrega una descripción',
                                    },
                                    ]}
                                >
                                    <Input placeholder="Por favor agrega una descripción" />
                                </Form.Item>
                            </Col>
                            {
                                concepts && concepts.length > 0 && 
                                <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                    <Form.Item
                                        name="concepto_id"
                                        label="Concepto"
                                        rules={[
                                        {
                                            required: true,
                                            message: 'Por favor selecciona el concepto',
                                        },
                                        ]}
                                    >
                                        <Select placeholder="Por favor selecciona el concepto" 
                                            showSearch
                                            filterOption={(input, option) =>
                                                (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                            }>
                                            {
                                                concepts.map((item)=><Option value={item.value}>{item.text}</Option>)
                                            }
                                        </Select>
                                    </Form.Item>
                                </Col>
                            }
                           <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="clase"
                                    label="Clase"
                                    >
                                    <Switch checkedChildren={'Incrementa'} unCheckedChildren={'Decrementa'}/>
                                </Form.Item>
                            </Col>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="usa_plazo"
                                    label="Usa Plazo"
                                    >
                                    <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />} onChange={(value)=>{setUsaPlazo(value)}}/>
                                </Form.Item>
                            </Col>
                            {
                                usa_plazo && 
                                <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                    <Form.Item
                                        name="plazo"
                                        label="Plazo"
                                        rules={[
                                        {
                                            required: true,
                                            message: 'Por favor agrega el plazo',
                                        },
                                        ]}
                                    >
                                        <InputNumber placeholder="Por favor agrega el plazo" />
                                    </Form.Item>
                                </Col>
                            }
                          
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="finiquito"
                                    label="Finiquito"
                                    >
                                    <Switch checkedChildren={'Saldar'} unCheckedChildren={'No Saldar'}/>
                                </Form.Item>
                            </Col>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="activo"
                                    label="Activo"
                                    >
                                    <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />}/>
                                </Form.Item>
                            </Col>
                        </Row>
                </Form>
            }
            </>
        </Drawer>
    );
};
export default App;